import { render, staticRenderFns } from "./InstagramDetail.vue?vue&type=template&id=54f7f758&scoped=true&"
import script from "./InstagramDetail.vue?vue&type=script&lang=js&"
export * from "./InstagramDetail.vue?vue&type=script&lang=js&"
import style0 from "./InstagramDetail.vue?vue&type=style&index=0&id=54f7f758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f7f758",
  null
  
)

export default component.exports